import axios from "axios";
import $ from "jquery";

// let authToken = 'Basic YWJjMTBAbWFpbGluYXRvci5jb206U2VjcmV0QDEyMw==' //for nepal
// let authToken = 'Basic YWRtaW46ZGlzdHJpY3Q=' // for intraavenir (Vizibuzz)
let authToken = 'Basic YWRtaW5pc3RyYXRvcjpTZWNyZXRAMTIz' //fpss administrator
//let authToken = "Basic ZnBwbmVwYWxAbWFpbGluYXRvci5jb206U2VjcmV0QDEyMw==" for fppnepal

class ApiServices {
    constructor() {}
    getAllKeys() {
      if (localStorage.getItem("authToken")) {
          authToken = localStorage.getItem("authToken")
      }
      return axios({
        method: 'get',
        url: `${settings.baseURL}/${settings.apiURL}/dataStore/${settings.tableName}`,
        headers: { Authorization: authToken }
      })
    }
    saveConfig(configData, key_in_table) {
      if (localStorage.getItem("authToken")) {
          authToken = localStorage.getItem("authToken")
      }
      return axios({
        method: 'post',
        url: `${settings.baseURL}/${settings.apiURL}/dataStore/${settings.tableName}/${key_in_table}`,
        headers: { Authorization: authToken },
        data: configData
      })
    }

    //This is used to update config into datastore.
    //It takes 2 argument(s) [configData = Data to be stored in JSON format, key_in_table = key name from datastore].
    //It uses variables stored globally in index.html file
    updateConfig(configData, key_in_table) {
      if (localStorage.getItem("authToken")) {
          authToken = localStorage.getItem("authToken")
      }
      return axios({
        method: 'put',
        url: `${settings.baseURL}/${settings.apiURL}/dataStore/${settings.tableName}/${key_in_table}`,
        headers: { Authorization: authToken },
        data: configData
      })
    }
    getSavedConfig(key_in_table) {
      if (localStorage.getItem("authToken")) {
          authToken = localStorage.getItem("authToken")
      }
      return axios({
        method: 'get',
        url: `${settings.baseURL}/${settings.apiURL}/dataStore/${settings.tableName}/${key_in_table}`,
        headers: { Authorization: authToken }
      })
    }
    getBaseUrl() {
        return `${settings.baseURL}`;
    }
    RestGetCall(url, inputObj, systemBasicAuth=null) {
      if(systemBasicAuth !== null) {
        if (localStorage.getItem("authToken")) {
            authToken = localStorage.getItem("authToken")
        }
      }
        // headers.Authorization == null ?  headers.Authorization =localStorage.getItem("authToken") : headers.Authorization;
        return axios
            .get(`${settings.baseURL}` + url, {
                headers: { Authorization: authToken },
                params: inputObj
            })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response;
            });
    }
    //This is used to get indicator groups
    getFilteredData(type, id) {
      let header ={}
      header={ Authorization: authToken}
      let url = null
      if (type === 'Indicators') {
        url = `indicators.json?fields=dimensionItem~rename(id),displayName~rename(label)&filter=indicatorGroups.id:eq:${id}&paging=false`
      }
      if (type === 'Data Elements') {
        url = `dataElements.json?fields=dimensionItem~rename(id),displayName~rename(label)&filter=domainType:eq:AGGREGATE&filter=dataElementGroups.id:eq:${id}&paging=false`
      }
      if (type === 'Event Data Items') {
        url = `programDataElements.json?program=${id}&fields=dimensionItem~rename(id),name~rename(label),valueType&paging=false`
      }
      if (type === 'Program Indicators') {
        url = `programs.json?filter=id:eq:${id}&fields=programIndicators%5BdimensionItem~rename(id),displayName~rename(label)%5D&paging=false`
      }

      return axios({
        method: 'get',
        url: `${settings.baseURL}/${settings.apiURL}/${url}`,
        headers: header
      })
    }
    getDataSourceGroups(type) {
        let header ={}
        header={ Authorization: authToken}
      let url = null
      if (type === 'Indicators') {
        url = `indicatorGroups.json?fields=id,displayName~rename(label)&paging=false&_dc=1571382237013&query=`
      }
      if (type === 'Data Elements') {
        url = `dataElementGroups.json?fields=id,displayName~rename(label)&paging=false&_dc=1571382430765&query=`
      }
      if (type === 'Data Sets') {
        url = `dataSets.json?fields=dimensionItem~rename(id),displayName~rename(label)&paging=false`
      }
      if (type === 'Event Data Items') {
        url = `programs.json?fields=id,displayName~rename(label)&paging=false&_dc=1571980902507`
      }
      if (type === 'Program Indicators') {
        url = `programs.json?fields=id,displayName~rename(label)&paging=false&_dc=1571980902507`
      }

      return axios({
        method: 'get',
        url: `${settings.baseURL}/${settings.apiURL}/${url}`,
        headers: header
      })
    }
    RestPostCall(url, inputObj, contentType=null) {
        if (localStorage.getItem("authToken")) {
            authToken = localStorage.getItem("authToken")
        }
        // headers.Authorization == null ?  headers.Authorization =localStorage.getItem("authToken") : headers.Authorization;
        // console.log(headers.Authorization);
        let header ={}
        if(contentType != null){
        header={ Authorization: authToken, 'Content-Type': contentType}
      }
        else {
          header={ Authorization: authToken}
        }
        return axios({
                method: "post",
                url: `${settings.baseURL}` + url,
                headers: header,
                data: inputObj
            }).then(response => {
                return response.data;
            })
            /*catch(error => {
              console.log(error);
              return error.response;
            });*/
    }

    //     RestPostCall(url, inputObj) {
    //     if (localStorage.getItem("authToken")) {
    //         authToken = localStorage.getItem("authToken")
    //     }
    //     // headers.Authorization == null ?  headers.Authorization =localStorage.getItem("authToken") : headers.Authorization;
    //     // console.log(headers.Authorization);
    //     return axios({
    //             method: "post",
    //             url: `${settings.baseURL}` + url,
    //             headers: { Authorization: authToken },
    //             data: inputObj
    //         }).then(response => {
    //             return response.data;
    //         })
    //         /*catch(error => {
    //           console.log(error);
    //           return error.response;
    //         });*/
    // }

    RestPutCall(url, inputObj) {
        if (localStorage.getItem("authToken")) {
            authToken = localStorage.getItem("authToken")
        }
        // headers.Authorization == null ?  headers.Authorization =localStorage.getItem("authToken") : headers.Authorization;
        // console.log(headers.Authorization);
        return axios({
                method: "put",
                url: `${settings.baseURL}` + url,
                headers: { Authorization: authToken },
                data: inputObj
            }).then(response => {
                return response.data;
            })
            /*catch(error => {
              console.log(error);
              return error.response;
            });*/
    }

    RestDeleteCall(url, inputObj) {
        if (localStorage.getItem("authToken")) {
            authToken = localStorage.getItem("authToken")
        }
        // headers.Authorization == null ?  headers.Authorization =localStorage.getItem("authToken") : headers.Authorization;
        // console.log(headers.Authorization);
        return axios({
                method: "delete",
                url: `${settings.baseURL}` + url,
                headers: { Authorization: authToken },

            }).then(response => {
                return response.data;
            })
            /*catch(error => {
              console.log(error);
              return error.response;
            });*/
    }

    RestPostMaltipart(url, inputObj) {
        if (localStorage.getItem("authToken")) {
            authToken = localStorage.getItem("authToken")
        }
        return axios({
                method: "post",
                url: `${settings.baseURL}` + url,
                headers: { 'Content-Type': 'multipart/form-data', Authorization: authToken },
                data: inputObj
            }).then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response;
            });
    }

    getOrganisationChildren(uid, level) {
      let orgLevel = 8;
      let url = `${settings.baseURL}/${settings.apiURL}/organisationUnits/${uid}.json?fields=id,displayName,level,children[id,displayName,level`
      for (let i = level; i <= orgLevel; i++) {
        url += ',children[id,displayName,level'
      }
      for (let i = level; i <= orgLevel; i++) {
        url += ']'
      }
      //console.log(url)
      return axios({
        method: 'get',
        url,
        headers: { Authorization: authToken }
      })
    }

    addOrganisationGroup(orgData) {
      return axios({
        method: 'post',
        url: `${settings.baseURL}/${settings.apiURL}/organisationUnitGroups`,
        headers: { Authorization: authToken },
        data: orgData
      })
    }

    updateOrganisationGroup(id, orgData) {
      return axios({
        method: 'put',
        url: `${settings.baseURL}/${settings.apiURL}/organisationUnitGroups/${id}?mergeMode=REPLACE`,
        headers: { Authorization: authToken },
        data: orgData
      })
    }
    deleteOrganisationGroup(id) {
      return axios({
        method: 'delete',
        url: `${settings.baseURL}/${settings.apiURL}/organisationUnitGroups/${id}`,
        headers: { Authorization: authToken }
      })
    }
    deleteMetaData(data, type) {
      console.log(data, type)
      let id = ''
      if(type == 'ele'){
        id = data.id
      }else if(type == 'org'){
        id = data.uid
      }
      return axios({
        method: 'post',
        url: `${settings.baseURL}/${settings.apiURL}/avenir/delete/deleteMetadata`,
        headers: { Authorization: authToken },
        data: {"orgs":[id]}
      })
    }
    getIndOrganisationGroup(id) {
      let url = `${settings.baseURL}/${settings.apiURL}/organisationUnitGroups/${id}.json`
      return axios.get(url, {
        headers: { Authorization: authToken }
      }).then((response => {
        return response
      }))
    }
    theme(color) {
        if (color === '#2b2b2b') {
            $("#mainbody").removeClass("white-theme");
            $("#mainbody").removeClass("green-theme");
            $("#mainbody").removeClass("newGreen-theme");
            $("#mainbody").removeClass("newBlack-theme");
            $("#mainbody").addClass("black-theme");
        } else if (color === '#212832') {
            $("#mainbody").removeClass("white-theme");
            $("#mainbody").removeClass("green-theme");
            $("#mainbody").removeClass("black-theme");
            $("#mainbody").removeClass("newGreen-theme");
            $("#mainbody").addClass("newBlack-theme");
        } else if (color === '#006600') {
            $("#mainbody").removeClass("white-theme");
            $("#mainbody").removeClass("black-theme");
            $("#mainbody").addClass("green-theme");
            $("#mainbody").removeClass("newBlack-theme");
            $("#mainbody").removeClass("newGreen-theme");
            //$("#mainbody").addClass("newGreen-theme");
        } else if (color === '#25984b') {
            $("#mainbody").removeClass("white-theme");
            $("#mainbody").removeClass("black-theme");
            $("#mainbody").removeClass("newBlack-theme");
            $("#mainbody").removeClass("green-theme");
            //$("#mainbody").addClass("green-theme");
            $("#mainbody").addClass("newGreen-theme");
        } else if (color === '#e5e5e5') {
            $("#mainbody").removeClass("green-theme");
            $("#mainbody").removeClass("newGreen-theme");
            $("#mainbody").removeClass("black-theme");
            $("#mainbody").removeClass("newBlack-theme");
            $("#mainbody").addClass("white-theme");
        } else {
            $("#mainbody").removeClass("white-theme");
            $("#mainbody").removeClass("green-theme");
            $("#mainbody").removeClass("black-theme");
            $("#mainbody").removeClass("newBlack-theme");
            $("#mainbody").removeClass("newGreen-theme");
        }
    }
}

export default new ApiServices();
